export const servicesData = {
  data: {
    services: [
      {
        type: 'corporate-executive',
        key: 'CORPORATE_EXECUTIVE_CARD',
        name: 'CORPORATE_EXECUTIVE_CARD.name',
        enabled: true,
        forceEnabled: false,
        imageUrl: '/img/CORPORATE_EXECUTIVE_CARD.png',
        header: 'CORPORATE_EXECUTIVE_CARD.header',
        shortDescription: 'CORPORATE_EXECUTIVE_CARD.short',
        longDescription: 'CORPORATE_EXECUTIVE_CARD.long',
        aboutServiceUrl: 'https://www.network.ae/en/contents/listing/payment-solutions#book-1',
        fields: [
          {
            type: 'checkbox',
            key: 'company',
            tag: 'HIERARCHY_LEVELS',
            name: 'CORPORATE_EXECUTIVE_CARD.company',
            value: {
              defaultValue: {
                checked: true,
              },
            },
            editable: {
              merchant: false,
              agent: false,
            },
          },
          {
            type: 'checkbox',
            key: 'region',
            tag: 'HIERARCHY_LEVELS',
            name: 'CORPORATE_EXECUTIVE_CARD.region',
            value: {
              defaultValue: {
                checked: false,
              },
            },
            editable: {
              merchant: true,
              agent: false,
            },
          },
          {
            type: 'checkbox',
            key: 'branch',
            tag: 'HIERARCHY_LEVELS',
            name: 'CORPORATE_EXECUTIVE_CARD.branch',
            value: {
              defaultValue: {
                checked: false,
              },
            },
            editable: {
              merchant: true,
              agent: false,
            },
          },
          {
            type: 'checkbox',
            key: 'department',
            tag: 'HIERARCHY_LEVELS',
            name: 'CORPORATE_EXECUTIVE_CARD.department',
            value: {
              defaultValue: {
                checked: false,
              },
            },
            editable: {
              merchant: true,
              agent: false,
            },
          },
          {
            type: 'checkbox',
            key: 'cardholder',
            tag: 'HIERARCHY_LEVELS',
            name: 'CORPORATE_EXECUTIVE_CARD.cardholder',
            value: {
              defaultValue: {
                checked: true,
              },
            },
            editable: {
              merchant: false,
              agent: false,
            },
          },
          {
            type: 'select',
            key: 'cashbackRedemmptionRebate',
            tag: 'CHASHBACK_REDEMPTION_REBATE',
            name: 'CORPORATE_EXECUTIVE_CARD.cashbackRedemmptionRebate',
            dropDownKey: 'CashbackRedemptionRebate',
            value: {
              defaultValue: {
                value: 'Annual',
              },
            },
            editable: {
              merchant: true,
              agent: false,
            },
          },
          {
            type: 'text',
            key: 'productPercentageBalance',
            tag: 'PRODUCT_PERCENTAGE_BALANCE',
            name: 'CORPORATE_EXECUTIVE_CARD.productPercentageBalance',
            editable: {
              merchant: true,
              agent: false,
            },
          },
          {
            type: 'info',
            key: 'monthlyFees',
            tag: 'ACCOUNT_MAINTAENANCE',
            name: 'CORPORATE_EXECUTIVE_CARD.monthlyFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'dormancyFees',
            tag: 'ACCOUNT_MAINTAENANCE',
            name: 'CORPORATE_EXECUTIVE_CARD.dormancyFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'cardIssuing',
            tag: 'CARD_ISSUANCE',
            name: 'CORPORATE_EXECUTIVE_CARD.cardIssuing',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'cardReplacement',
            tag: 'CARD_ISSUANCE',
            name: 'CORPORATE_EXECUTIVE_CARD.cardReplacement',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'cardRenewal',
            tag: 'CARD_ISSUANCE',
            name: 'CORPORATE_EXECUTIVE_CARD.cardRenewal',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'cardDeilvery',
            tag: 'CARD_ISSUANCE',
            name: 'CORPORATE_EXECUTIVE_CARD.cardDeilvery',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'virtualCardGeneration',
            tag: 'CARD_ISSUANCE',
            name: 'CORPORATE_EXECUTIVE_CARD.virtualCardGeneration',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'ATMCashUAESwitch',
            tag: 'TRANSACTION_FEES',
            name: 'CORPORATE_EXECUTIVE_CARD.ATMCashUAESwitch',
            value: {
              defaultValue: {
                amount: {
                  value: 2,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'ATMCashUAENonSwitch',
            tag: 'TRANSACTION_FEES',
            name: 'CORPORATE_EXECUTIVE_CARD.ATMCashUAENonSwitch',
            value: {
              defaultValue: {
                amount: {
                  value: 5,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'ATMCashInternationalATM',
            tag: 'TRANSACTION_FEES',
            name: 'CORPORATE_EXECUTIVE_CARD.ATMCashInternationalATM',
            value: {
              defaultValue: {
                amount: {
                  value: 27,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'ForeignExchange',
            tag: 'TRANSACTION_FEES',
            name: 'CORPORATE_EXECUTIVE_CARD.ForeignExchange',
            value: {
              defaultValue: {
                percent: 2.6,
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'dCCForeign',
            tag: 'TRANSACTION_FEES',
            name: 'CORPORATE_EXECUTIVE_CARD.dCCForeign',
            value: {
              defaultValue: {
                percent: 2.6,
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'UAECurrency',
            tag: 'TRANSACTION_FEES',
            name: 'CORPORATE_EXECUTIVE_CARD.UAECurrency',
            value: {
              defaultValue: {
                percent: 2.6,
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'chargebackFees',
            tag: 'TRANSACTION_FEES',
            name: 'CORPORATE_EXECUTIVE_CARD.chargebackFees',
            value: {
              defaultValue: {
                amount: {
                  value: 25,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: '3DSecureAuthentication',
            tag: 'TRANSACTION_FEES',
            name: 'CORPORATE_EXECUTIVE_CARD.3DSecureAuthentication',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'fraudMonitoringFees',
            tag: 'TRANSACTION_FEES',
            name: 'CORPORATE_EXECUTIVE_CARD.fraudMonitoringFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'Self-servicePortalAccessFees',
            tag: 'PPRTALS_STATEMENTS_NOTIFICATIONS',
            name: 'CORPORATE_EXECUTIVE_CARD.servicePortalAccessFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'expenseManagement',
            tag: 'PPRTALS_STATEMENTS_NOTIFICATIONS',
            name: 'CORPORATE_EXECUTIVE_CARD.expenseManagement',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'eStatementFees',
            tag: 'PPRTALS_STATEMENTS_NOTIFICATIONS',
            name: 'CORPORATE_EXECUTIVE_CARD.eStatementFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'SMSFees',
            tag: 'PPRTALS_STATEMENTS_NOTIFICATIONS',
            name: 'CORPORATE_EXECUTIVE_CARD.SMSFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'eMailFees',
            tag: 'PPRTALS_STATEMENTS_NOTIFICATIONS',
            name: 'CORPORATE_EXECUTIVE_CARD.eMailFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
        ],
      },
      {
        type: 'digital-busines-payments',
        key: 'DIGITAL_BUSINESS_PAYMENT',
        name: 'DIGITAL_BUSINESS_PAYMENT.name',
        enabled: true,
        forceEnabled: false,
        imageUrl: '/img/DIGITAL_BUSINESS_PAYMENT.png',
        header: 'DIGITAL_BUSINESS_PAYMENT.header',
        shortDescription: 'DIGITAL_BUSINESS_PAYMENT.short',
        longDescription: 'DIGITAL_BUSINESS_PAYMENT.long',
        aboutServiceUrl: 'https://www.network.ae/en/contents/listing/online-solutions#book-1',
        fields: [
          {
            type: 'checkbox',
            key: 'company',
            tag: 'HIERARCHY_LEVELS',
            name: 'DIGITAL_BUSINESS_PAYMENT.company',
            value: {
              defaultValue: {
                checked: true,
              },
            },
            editable: {
              merchant: false,
              agent: false,
            },
          },
          {
            type: 'checkbox',
            key: 'region',
            tag: 'HIERARCHY_LEVELS',
            name: 'DIGITAL_BUSINESS_PAYMENT.region',
            value: {
              defaultValue: {
                checked: false,
              },
            },
            editable: {
              merchant: true,
              agent: false,
            },
          },
          {
            type: 'checkbox',
            key: 'branch',
            tag: 'HIERARCHY_LEVELS',
            name: 'DIGITAL_BUSINESS_PAYMENT.branch',
            value: {
              defaultValue: {
                checked: false,
              },
            },
            editable: {
              merchant: true,
              agent: false,
            },
          },
          {
            type: 'checkbox',
            key: 'department',
            tag: 'HIERARCHY_LEVELS',
            name: 'DIGITAL_BUSINESS_PAYMENT.department',
            value: {
              defaultValue: {
                checked: true,
              },
            },
            editable: {
              merchant: true,
              agent: false,
            },
          },
          {
            type: 'select',
            key: 'cashbackRedemmptionRebate',
            tag: 'CHASHBACK_REDEMPTION_REBATE',
            name: 'DIGITAL_BUSINESS_PAYMENT.cashbackRedemmptionRebate',
            dropDownKey: 'CashbackRedemptionRebate',
            value: {
              defaultValue: {
                value: 'Annual',
              },
            },
            editable: {
              merchant: true,
              agent: false,
            },
          },
          {
            type: 'text',
            key: 'productPercentageBalance',
            tag: 'PRODUCT_PERCENTAGE_BALANCE',
            name: 'DIGITAL_BUSINESS_PAYMENT.productPercentageBalance',
            editable: {
              merchant: true,
              agent: false,
            },
          },
          {
            type: 'info',
            key: 'annualCardFee',
            tag: 'ACCOUNT_MAINTAENANCE',
            name: 'DIGITAL_BUSINESS_PAYMENT.annualCardFee',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'monthlyFees',
            tag: 'ACCOUNT_MAINTAENANCE',
            name: 'DIGITAL_BUSINESS_PAYMENT.monthlyFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'dormancyFees',
            tag: 'ACCOUNT_MAINTAENANCE',
            name: 'DIGITAL_BUSINESS_PAYMENT.dormancyFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'cardIssuing',
            tag: 'CARD_ISSUANCE',
            name: 'DIGITAL_BUSINESS_PAYMENT.cardIssuing',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'cardReplacement',
            tag: 'CARD_ISSUANCE',
            name: 'DIGITAL_BUSINESS_PAYMENT.cardReplacement',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'cardRenewal',
            tag: 'CARD_ISSUANCE',
            name: 'DIGITAL_BUSINESS_PAYMENT.cardRenewal',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'cardDeilvery',
            tag: 'CARD_ISSUANCE',
            name: 'DIGITAL_BUSINESS_PAYMENT.cardDeilvery',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'virtualCardGeneration',
            tag: 'CARD_ISSUANCE',
            name: 'DIGITAL_BUSINESS_PAYMENT.virtualCardGeneration',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'ForeignExchange',
            tag: 'TRANSACTION_FEES',
            name: 'DIGITAL_BUSINESS_PAYMENT.ForeignExchange',
            value: {
              defaultValue: {
                percent: 2.9,
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'dCCForeign',
            tag: 'TRANSACTION_FEES',
            name: 'DIGITAL_BUSINESS_PAYMENT.dCCForeign',
            value: {
              defaultValue: {
                percent: 2.9,
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'UAECurrency',
            tag: 'TRANSACTION_FEES',
            name: 'DIGITAL_BUSINESS_PAYMENT.UAECurrency',
            value: {
              defaultValue: {
                percent: 2.9,
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'chargebackFees',
            tag: 'TRANSACTION_FEES',
            name: 'DIGITAL_BUSINESS_PAYMENT.chargebackFees',
            value: {
              defaultValue: {
                amount: {
                  value: 25,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: '3DSecureAuthentication',
            tag: 'TRANSACTION_FEES',
            name: 'DIGITAL_BUSINESS_PAYMENT.3DSecureAuthentication',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'fraudMonitoringFees',
            tag: 'TRANSACTION_FEES',
            name: 'DIGITAL_BUSINESS_PAYMENT.fraudMonitoringFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'Self-servicePortalAccessFees',
            tag: 'PPRTALS_STATEMENTS_NOTIFICATIONS',
            name: 'DIGITAL_BUSINESS_PAYMENT.servicePortalAccessFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'expenseManagement',
            tag: 'PPRTALS_STATEMENTS_NOTIFICATIONS',
            name: 'DIGITAL_BUSINESS_PAYMENT.expenseManagement',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'eStatementFees',
            tag: 'PPRTALS_STATEMENTS_NOTIFICATIONS',
            name: 'DIGITAL_BUSINESS_PAYMENT.eStatementFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'SMSFees',
            tag: 'PPRTALS_STATEMENTS_NOTIFICATIONS',
            name: 'DIGITAL_BUSINESS_PAYMENT.SMSFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'eMailFees',
            tag: 'PPRTALS_STATEMENTS_NOTIFICATIONS',
            name: 'DIGITAL_BUSINESS_PAYMENT.eMailFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
        ],
      },
      {
        type: 'digital-business-travel',
        key: 'DIGITAL_TRAVEL_PAYMENT',
        name: 'DIGITAL_TRAVEL_PAYMENT.name',
        enabled: true,
        forceEnabled: false,
        imageUrl: '/img/DIGITAL_TRAVEL_PAYMENT.png',
        header: 'DIGITAL_TRAVEL_PAYMENT.header',
        shortDescription: 'DIGITAL_TRAVEL_PAYMENT.short',
        additionalBannerDescription: 'DIGITAL_TRAVEL_PAYMENT.additional',
        longDescription: 'DIGITAL_TRAVEL_PAYMENT.long',
        aboutServiceUrl: 'https://www.network.ae/en/contents/lists/merchantsolutions',
        fields: [
          {
            type: 'checkbox',
            key: 'company',
            tag: 'HIERARCHY_LEVELS',
            name: 'DIGITAL_TRAVEL_PAYMENT.company',
            value: {
              defaultValue: {
                checked: true,
              },
            },
            editable: {
              merchant: false,
              agent: false,
            },
          },
          {
            type: 'checkbox',
            key: 'region',
            tag: 'HIERARCHY_LEVELS',
            name: 'DIGITAL_TRAVEL_PAYMENT.region',
            value: {
              defaultValue: {
                checked: false,
              },
            },
            editable: {
              merchant: true,
              agent: false,
            },
          },
          {
            type: 'checkbox',
            key: 'branch',
            tag: 'HIERARCHY_LEVELS',
            name: 'DIGITAL_TRAVEL_PAYMENT.branch',
            value: {
              defaultValue: {
                checked: false,
              },
            },
            editable: {
              merchant: true,
              agent: false,
            },
          },
          {
            type: 'checkbox',
            key: 'department',
            tag: 'HIERARCHY_LEVELS',
            name: 'DIGITAL_TRAVEL_PAYMENT.department',
            value: {
              defaultValue: {
                checked: false,
              },
            },
            editable: {
              merchant: true,
              agent: false,
            },
          },
          {
            type: 'select',
            key: 'cashbackRedemmptionRebate',
            tag: 'CHASHBACK_REDEMPTION_REBATE',
            name: 'DIGITAL_TRAVEL_PAYMENT.cashbackRedemmptionRebate',
            dropDownKey: 'CashbackRedemptionRebate',
            value: {
              defaultValue: {
                value: 'Annual',
              },
            },
            editable: {
              merchant: true,
              agent: false,
            },
          },
          {
            type: 'text',
            key: 'productPercentageBalance',
            tag: 'PRODUCT_PERCENTAGE_BALANCE',
            name: 'DIGITAL_TRAVEL_PAYMENT.productPercentageBalance',
            editable: {
              merchant: true,
              agent: false,
            },
          },
          {
            type: 'info',
            key: 'annualCardFee',
            tag: 'ACCOUNT_MAINTAENANCE',
            name: 'DIGITAL_TRAVEL_PAYMENT.annualCardFee',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'monthlyFees',
            tag: 'ACCOUNT_MAINTAENANCE',
            name: 'DIGITAL_TRAVEL_PAYMENT.monthlyFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'dormancyFees',
            tag: 'ACCOUNT_MAINTAENANCE',
            name: 'DIGITAL_TRAVEL_PAYMENT.dormancyFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'cardIssuing',
            tag: 'CARD_ISSUANCE',
            name: 'DIGITAL_TRAVEL_PAYMENT.cardIssuing',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'cardReplacement',
            tag: 'CARD_ISSUANCE',
            name: 'DIGITAL_TRAVEL_PAYMENT.cardReplacement',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'cardRenewal',
            tag: 'CARD_ISSUANCE',
            name: 'DIGITAL_TRAVEL_PAYMENT.cardRenewal',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'cardDeilvery',
            tag: 'CARD_ISSUANCE',
            name: 'DIGITAL_TRAVEL_PAYMENT.cardDeilvery',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'virtualCardGeneration',
            tag: 'CARD_ISSUANCE',
            name: 'DIGITAL_TRAVEL_PAYMENT.virtualCardGeneration',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'ForeignExchange',
            tag: 'TRANSACTION_FEES',
            name: 'DIGITAL_TRAVEL_PAYMENT.ForeignExchange',
            value: {
              defaultValue: {
                percent: 0,
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'dCCForeign',
            tag: 'TRANSACTION_FEES',
            name: 'DIGITAL_TRAVEL_PAYMENT.dCCForeign',
            value: {
              defaultValue: {
                percent: 2.6,
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'UAECurrency',
            tag: 'TRANSACTION_FEES',
            name: 'DIGITAL_TRAVEL_PAYMENT.UAECurrency',
            value: {
              defaultValue: {
                percent: 2.6,
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'chargebackFees',
            tag: 'TRANSACTION_FEES',
            name: 'DIGITAL_TRAVEL_PAYMENT.chargebackFees',
            value: {
              defaultValue: {
                amount: {
                  value: 25,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: '3DSecureAuthentication',
            tag: 'TRANSACTION_FEES',
            name: 'DIGITAL_TRAVEL_PAYMENT.3DSecureAuthentication',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'fraudMonitoringFees',
            tag: 'TRANSACTION_FEES',
            name: 'DIGITAL_TRAVEL_PAYMENT.fraudMonitoringFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'Self-servicePortalAccessFees',
            tag: 'PPRTALS_STATEMENTS_NOTIFICATIONS',
            name: 'DIGITAL_TRAVEL_PAYMENT.servicePortalAccessFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'expenseManagement',
            tag: 'PPRTALS_STATEMENTS_NOTIFICATIONS',
            name: 'DIGITAL_TRAVEL_PAYMENT.expenseManagement',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'eStatementFees',
            tag: 'PPRTALS_STATEMENTS_NOTIFICATIONS',
            name: 'DIGITAL_TRAVEL_PAYMENT.eStatementFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'SMSFees',
            tag: 'PPRTALS_STATEMENTS_NOTIFICATIONS',
            name: 'DIGITAL_TRAVEL_PAYMENT.SMSFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
          {
            type: 'info',
            key: 'eMailFees',
            tag: 'PPRTALS_STATEMENTS_NOTIFICATIONS',
            name: 'DIGITAL_TRAVEL_PAYMENT.eMailFees',
            value: {
              defaultValue: {
                amount: {
                  value: 0,
                  currency: 'AED',
                },
              },
            },
            validation: {
              amount: {
                min: 0.0,
                max: 1000.0,
              },
            },
            editable: {
              merchant: false,
              agent: true,
            },
          },
        ],
      },
    ],
    additionalConfigurations: [],
  },
};
